import React, { useContext, useState, useEffect } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useAuth0 } from '@auth0/auth0-react';
import LinearProgress from '@mui/material/LinearProgress';
import ProjectContext from '../../contexts/ProjectContext';
import {useFetch} from '../../components/auth/useFetch';

// In milliseconds
let minimumLoadingAnimationDuration = 2000;

export default function ReceiptDataGrid(props) {
    const [loading, setLoading] = useState(false)

    const {  isAuthenticated } = useAuth0();
    const projectContext = useContext(ProjectContext);
    const [value, setValue] = useState(0);
    const fetchWithAuth = useFetch()

    const columns = [
        { field: 'title', headerName: 'Camera Format', width: 250 },
        { field: 'pipeline', headerName: 'Pipeline', width: 1000 },]

    const [rows, setRows] = React.useState([])
    const pipelines = () => {
        var myHeaders = new Headers();
        var formdata = new FormData();

        var requestOptions = {
          method: 'GET',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow',
        };
        setLoading(true)
        let startTime = new Date();
        
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/pipeline`, {
            headers: {
                'X-Project-ID': projectContext?.project_db
            },
        })
          .then(response => response.json())
          .then(result => {
            setRows(result)
            // Handle loading anim time
            let endTime = new Date();
            if (endTime.getTime() - startTime.getTime() < minimumLoadingAnimationDuration){
            let waitTime = minimumLoadingAnimationDuration - (endTime.getTime() - startTime.getTime());
            setTimeout(()=>{setLoading(false)}, waitTime)
            } else {
                setLoading(false)
            }
        })
        .catch(e => {
            console.error(e);
        })
    }


    useEffect(() => {
        isAuthenticated && (() => {
            pipelines()
            })()
        }, [isAuthenticated])

    return (
        <DataGridPro
            sx={{
                bgcolor: "rgba(0,0,0,0.9)",
                boxShadow: 2,
                border: 0,
                '& .MuiSvgIcon-root': {
                    color: "rgba(178, 186, 194, 0.4)"
                },
                '& .MuiDataGrid-footerContainer': {
                    borderTop: "1px solid rgba(224, 224, 224, 0.8)"
                },
                '& .MuiDataGrid-overlay': {
                    backgroundColor: "rgba(255, 255, 255, 0.01)"
                },
                '& .MuiDataGrid-row.Mui-selected': {
                    backgroundColor: "rgba(36, 108, 164, 0.35)",
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                    color: "rgb(255, 255, 255)",
                    fontWeight: "bold",
                },
                '& .MuiDataGrid-columnHeadersInner': {
                    backgroundColor: "rgba(0, 0,0 , 0.1)",
                },
                '& .MuiDataGrid-pinnedColumns': {
                    backgroundColor: "#1c2025",
                    backgroundImage: 'none',
                    
                    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 50%), 0px 2px 2px 0px rgb(0 0 0 / 40%), 0px 1px 5px 0px rgb(36 108 164 / 90%)',
                },
                '& .MuiDataGrid-pinnedColumnHeaders': {
                    backgroundColor: "rgb(40,44,52)",
                    backgroundImage: 'none',
                    boxShadow: 'none',
                    borderColor: "rgba(77, 78, 82, 0.7)",
                },              
                '& .MuiDataGrid-cell': {
                color: "rgb(255, 255, 255)",
                borderColor: "rgba(77, 78, 82, 0.7)",
                },
                '& .MuiDataGrid-virtualScroller': {
                    flex: "1 1 0px",
                    overflow: "auto"
                },
                '& .MuiLinearProgress-root':{
                    backgroundColor:'green'
                },
                
            }}
            loading={loading}
            components={{ 
                LoadingOverlay: LinearProgress, 
            }}
            rows={rows}
            columns={columns}
        />
    )
}
